import { makeAction, makeReducer } from '@finn-no/redux-actions';

import { getFilterValuesFromUrl, updateUrl } from './urlState.js';
import { filterQuery } from '../polling/query.js';

import baseActions from './actions.js';
import savedSearchActions from './savedSearchActions.js';
import { gtmActions } from './gtm.js';

const actions = {};

actions.updateFilters = payload => (dispatch, getState) => {
    const updatedFilterState = { ...getState().filterState, ...payload };

    updateUrl(updatedFilterState);
    dispatch(baseActions.setLoading(true));
    dispatch(actions.setFilters(payload));
    dispatch(savedSearchActions.filterUpdate(updatedFilterState));
    dispatch(gtmActions.filterChange(payload));
    dispatch(baseActions.showBanners());
    // Add actions/changes relating to 'resultViewCriteria:changed' here..

    return fetch(`result/${getState().searchId}?${filterQuery(updatedFilterState, getState().filterData)}`, {
        method: 'GET',
        cache: 'no-cache',
    })
        .then(response => {
            if (response.status >= 200 && response.status < 300) {
                return response.json();
            }
            if (response.status === 410) {
                document.location.hash = 'resultExpired';
                document.location.reload();
            }
            return Promise.reject(response.status);
        })
        .then(data => dispatch(baseActions.setResultData({ ...data, showProgressIndicator: false })))
        .catch(err => {
            throw new TypeError(`Filter search failed: ${JSON.stringify(err)}`);
        });
};

actions.setFilters = makeAction('FILTERS/SET_DATA', (state, { payload }) => ({ ...state, ...payload }));

actions.setFiltersFromUrl = makeAction('FILTERS/FROM_URL', state => ({ ...state, ...getFilterValuesFromUrl() }));

actions.resetFilters = makeAction('FILTERS/RESET', (state, { payload }) => {
    const newFilterState = Object.assign({}, state);

    const keysToDelete = payload.exceptions
        ? Object.keys(newFilterState).filter(item => payload.exceptions.indexOf(item) === -1)
        : Object.keys(newFilterState);

    for (const key of keysToDelete) {
        delete newFilterState[key];
    }

    if (payload.sortCriteria) {
        newFilterState.sortCriteria = payload.sortCriteria;
    }

    if (FINN.travel.unCheckedFilters) {
        Object.keys(FINN.travel.unCheckedFilters).forEach(key => {
            if (!payload.exceptions || payload.exceptions.indexOf(key) === -1) {
                newFilterState[key] = FINN.travel.unCheckedFilters[key];
            }
        });
    }

    return newFilterState;
});

export default actions;

export const reducer = makeReducer(actions);
